<template>
  <InputAuto
    ref="sug"
    v-model="selected"
    :template="template"
    :scope="scope"
    :errorsBag="errorsBag"
    :label="label"
    :name="name"
    :isLoading="isLoading"
    :sugestoes="sugestoes"
    :disabled="habilitarCampo()"
    :camposMostrarInput="['codigo', 'nome']"
    :camposFiltrar="['codigo', 'nome']"
    :erroConexao="erroConexao"
    :rotaTelaCadastro="'rota-produtos-cadastro'"
    separador=" - "
    msgSemRegistros='Não há produtos cadastrados...' />
</template>

<script>
import InputAuto from '@/components/inputs/autocomplete/InputAuto.vue'
import InputAutoMixin from '@/components/inputs/autocomplete/InputAutoMixin'

import TemplateProdutos from './templates/TemplateProdutos.vue'
import ProdutoService from '../../../services/produtos.service'

export default {
  name: 'InputSugestaoProdutos',
  mixins: [InputAutoMixin],
  components: {
    InputAuto,
  },
  data() {
    return {
      template: TemplateProdutos,
    }
  },
  methods: {
    async carregaTudo() {
      try {
        this.erroConexao = false
        this.isLoading = true
        const retorno = await ProdutoService.retornaTodosSemLimite()
        this.sugestoes = retorno.lista
      } catch (error) {
        this.erroConexao = error.tipo === 'MSG_ERRO'
        this.sugestoes = []
      } finally {
        this.isLoading = false
      }
    },
  },
}

</script>
